.google-auth-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 20px;
  text-align: center;
  max-width: 400px;
  margin: 0 auto;

  .auth-header {
    margin-bottom: 24px;

    .lock-icon {
      width: 48px;
      height: 48px;
      margin: 0 auto;
      color: #1677ff;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    h2 {
      color: #333;
      font-size: 16px;
      font-weight: normal;
      margin: 0;
    }
  }

  .verification-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;

    p {
      margin-bottom: 24px;
      color: #333;
      font-size: 14px;
    }

    .get-qr-button,
    .get-code-button {
      padding: 8px 16px;
      background-color: #1677ff;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s;

      &:hover {
        background-color: #4096ff;
      }

      &:disabled {
        background-color: #d9d9d9;
        cursor: not-allowed;
      }
    }

    .qr-code {
      margin-top: 24px;

      img {
        max-width: 200px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        padding: 8px;
      }
    }

    .code-input-group {
      display: flex;
      gap: 8px;
      justify-content: center;
      margin-bottom: 24px;

      input {
        width: 40px;
        height: 40px;
        text-align: center;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        font-size: 18px;
        outline: none;

        &:focus {
          border-color: #1677ff;
          box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.2);
        }

        &:disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
        }
      }
    }
  }

  .trust-device {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #666;
    font-size: 14px;
    margin-top: 16px;

    input[type="checkbox"] {
      margin: 0;
    }
  }

  .mfa-help {
    color: #4285f4;
    text-decoration: none;
    font-size: 14px;
    margin-top: 16px;

    &:hover {
      text-decoration: underline;
    }
  }

  .error-message {
    color: #ff4d4f;
    margin-top: 16px;
    font-size: 14px;
  }

  .success-message {
    color: #52c41a;
    margin-top: 16px;
    font-size: 14px;
  }
}

.qr-section {
  text-align: center;

  h3 {
    color: #333;
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 20px;
  }

  img {
    max-width: 200px;
    height: auto;
    margin-top: 10px;
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 4px;
  }
}
